import React from "react";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import _ from "lodash";

import messages from "constants/locales";

export default connect(state => {
  const locale = _.get(state, "app.user.profile.Language", "nl");

  return {
    key: locale,
    locale,
    messages: messages[locale],
    textComponent: React.Fragment
  };
})(IntlProvider);
